import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@material-ui/core";
import React, {FC, useState} from "react";
import {grey} from "@material-ui/core/colors";
import EditModalContent from "view/apps/Organiser/pages/Show/Settings/ElectronicSignature/EditModal/EditModalContent";
import FlexBox from "view/components/Layout/FlexBox";
import {RawAttachmentFile} from "ts/api/attachmentFile";
import {useStyles} from "./styles";
import {ViewModeEnum} from "../types";

type Props = {
  selectedOption: ViewModeEnum;
  setSelectedOption: React.Dispatch<React.SetStateAction<ViewModeEnum>>;
  activeTab: number;
  setActiveTab: React.Dispatch<React.SetStateAction<number>>;
  setPaintedFile: React.Dispatch<
    React.SetStateAction<RawAttachmentFile | null>
  >;
  uploadedFile: RawAttachmentFile | null;
  setUploadedFile: React.Dispatch<
    React.SetStateAction<RawAttachmentFile | null>
  >;
  setTypedFile: React.Dispatch<React.SetStateAction<RawAttachmentFile | null>>;
  signatureText: string;
  setSignatureText: React.Dispatch<React.SetStateAction<string>>;
  saveSignature: boolean;
  setSaveSignature: React.Dispatch<React.SetStateAction<boolean>>;
  signatureOptionContainerClass: string;
  radioGroupClass: string;
  labelTextClass: string;
  isOnlyNewViewMode?: boolean;
};

const NewSignaturesContainer: FC<Props> = ({
  selectedOption,
  setSelectedOption,
  activeTab,
  setActiveTab,
  setPaintedFile,
  uploadedFile,
  setUploadedFile,
  setTypedFile,
  signatureText,
  setSignatureText,
  saveSignature,
  setSaveSignature,
  signatureOptionContainerClass,
  radioGroupClass,
  labelTextClass,
  isOnlyNewViewMode,
}) => {
  const classes = useStyles();
  const [showCanvas, setShowCanvas] = useState(true);

  const handleSaveSignatureChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSaveSignature(event.target.checked);
  };

  return (
    <Box className={signatureOptionContainerClass}>
      <RadioGroup
        value={selectedOption}
        onChange={() => {
          setSelectedOption(ViewModeEnum.new);
        }}
        className={radioGroupClass}
      >
        {!isOnlyNewViewMode && (
          <FormControlLabel
            value={ViewModeEnum.new}
            control={<Radio color="primary" />}
            label={
              <FlexBox alignCenter>
                <Typography
                  variant="body1"
                  className={labelTextClass}
                  style={{
                    color: selectedOption === "new" ? "black" : grey[600],
                  }}
                >
                  Create a New Signature
                </Typography>
              </FlexBox>
            }
          />
        )}

        {selectedOption === "new" && (
          <Box className={classes.newSignatureContainer}>
            <EditModalContent
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              setPaintedFile={setPaintedFile}
              uploadedFile={uploadedFile}
              setUploadedFile={setUploadedFile}
              setTypedFile={setTypedFile}
              signatureText={signatureText}
              setSignatureText={setSignatureText}
              showCanvas={showCanvas}
              setShowCanvas={setShowCanvas}
            />
            {!isOnlyNewViewMode && (
              <FormControl>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={saveSignature}
                      onChange={handleSaveSignatureChange}
                      color="primary"
                    />
                  }
                  label="Save as my Signature"
                  className={classes.saveSignatureCheckBox}
                  classes={{label: classes.customLabel}}
                />
              </FormControl>
            )}
          </Box>
        )}
      </RadioGroup>
    </Box>
  );
};

export default NewSignaturesContainer;
